import * as React from "react";
import Menu from "../src/components/menu.component";
import BottomMenu from "./components/bottommenu.component";
import CookieComponent from "./components/cookie.component";
import SocialMenu from "./components/socialmenu.component";
import Router from "./Router";
import "./styles/css/main.css";
const fikafylogo = require("./images/fikafy-logo.png");

class App extends React.Component {
  render(): JSX.Element {
    return (
      <div className="App">
        <Menu />
        <div className="fikafy-logo-container">
          < a href="/" >
            <img src={fikafylogo} />
          </a >
        </div >
        {Router}
        < SocialMenu />
        <BottomMenu />
        <div className="bottom-copyright">© Fikafy 2020<br /><br />Made with<br />
          <div className="html-heart">&hearts;</div>
        </div>
        <CookieComponent />
      </div >
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx